import React from 'react';
import { Sidebar } from 'primereact/sidebar';
import { FormProvider, useForm, useFormContext } from 'react-hook-form';
import { ARFiltersArgs } from '../../accountsReceivables/ARFilter/ARFilters';
import JCBillReceiptsDrilldown from './JCBillReceiptsDrilldown';
import { useQuery } from '@tanstack/react-query';
import { ProgressSpinner } from 'primereact/progressspinner';
import ErrorMessage from '../../../../components/messages/ErrorMessage';
import { JobContractFilters } from '../JCFilters';
import { fecthContractCustomer } from '../../../../services/accounting/ContractBillingsService';
import { useCompanyContext } from '../../../../context/CompanyContext';

type JCBillReceiptsDrilldownContainerProps = {
  visible: boolean;
  hideDrilldown: () => void;
  contract: string;
  contractName: string;
};

const JCBillReceiptsDrilldownContainer = ({
  visible,
  hideDrilldown,
  contract,
  contractName,
}: JCBillReceiptsDrilldownContainerProps) => {
  const { selectedCompany } = useCompanyContext();
  const { watch } = useFormContext<JobContractFilters>();
  const filters = watch();
  const dates = [filters.startDate ?? undefined, filters.endDate];
  const methods = useForm<ARFiltersArgs>({
    defaultValues: { contracts: [contract], dates },
  });

  const { data, isFetching, isError, isSuccess } = useQuery({
    queryKey: ['getJCContractCustomer', selectedCompany, contract],
    queryFn: ({ signal }) =>
      fecthContractCustomer(selectedCompany!.id, contract, signal),
    refetchOnWindowFocus: false,
    enabled: !!selectedCompany,
  });

  return (
    <Sidebar
      visible={visible}
      position="right"
      onHide={hideDrilldown}
      className="w-full max-w-1500px"
    >
      {isFetching && (
        <div className="mx-8 h-full flex align-items-center">
          <ProgressSpinner />
        </div>
      )}
      {isError && (
        <div className="h-full flex align-items-center">
          <ErrorMessage
            content={'Failed to obtain data! Please try again later.'}
          />
        </div>
      )}
      {isSuccess && (
        <FormProvider {...methods}>
          <JCBillReceiptsDrilldown
            contract={contract}
            contractName={contractName}
            customerName={data.Name}
            startDate={filters.startDate ?? undefined}
            endDate={filters.endDate}
          />
        </FormProvider>
      )}
    </Sidebar>
  );
};

export default JCBillReceiptsDrilldownContainer;
